export default __webpack_public_path__ + "static/WheelChairRamp502x502-f8d7f79d277467fa387bcb56e674df99.png";